// Values are always in snake_case
// Naming convention is coming from PostHog's best practices: https://posthog.com/docs/product-analytics/best-practices

export const EVENT_CATEGORIES = {
  SIMULATION: 'simulation',
  SUBSCRIPTION: 'subscription' // registration flow, but is called "subscription" in all events
} as const

export const EVENT_ACTIONS = {
  ADD: 'add',
  CANCEL: 'cancel',
  CLICK: 'click',
  CREATE: 'create',
  CONFIRM: 'confirm',
  DELETE: 'delete',
  END: 'end',
  FAIL: 'fail',
  FINISH: 'finish',
  GENERATE: 'generate',
  INVITE: 'invite',
  REMOVE: 'remove',
  SEND: 'send',
  START: 'start',
  SUBMIT: 'submit',
  UPDATE: 'update',
  VIEW: 'view'
} as const

export const FEATURE_FLAGS = {
  simulationCtaText: 'start-simulation-cta-text',
  simulationCardHeadline: 'simulation-card-headline',
  recommendedProductText: 'recommended-product-text'
}
